<template>
  <div>
    <div class="container" ref="container"></div>
    <section :id="sectionId(section)" class="section" v-if="section.visible" v-for="(section, index) in getSections()">
      <slot name="page" :section="section" :index="index"></slot>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'page',
  props: {
    category: {
      type: String,
      required: true,
    },
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
    this.setContainerSize()
  },
  computed: {
    ...mapGetters(['sections'])
  },
  methods: {
    setContainerSize: function () {
      const width = (this.$refs['container'].clientWidth)
      const marginLeft = (window.innerWidth - width) / 2
      this.updateContainerSize({ width, marginLeft })
    },
    getSections: function (opts) {
      return this.sections.filter(function(section) {
        return section.category == this.category
      }.bind(this))
    },
    sectionId: function (section) {
      return section.id
    },
    handleResize: function () {
      this.setContainerSize()
    },
    ...mapActions(['updateContainerSize'])
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Page.vue